import type {FoodGrubhubCartItem, FoodGrubhubCartOption} from '@/lib/food-grubhub/foodGrubhubCartDb'

export default function flattenSelectedOptions(
  selectedOptions: FoodGrubhubCartItem['options'] | undefined,
) {
  const flatMap = new Map<string, FoodGrubhubCartOption>()

  if (!selectedOptions) {
    return flatMap
  }

  function traverse(options: FoodGrubhubCartOption[]) {
    for (const option of options) {
      flatMap.set(option.id, option)

      if (option.childOptions) {
        traverse(option.childOptions)
      }
    }
  }

  traverse(selectedOptions)
  return flatMap
}
